import client from '@lib/http/client'

export const importLandingFromFile = (formData: FormData) =>
  client.post('landing-page/landings/create-from-file', formData)
